import ConsumerSearch from './ConsumerSearch';

export default ConsumerSearch;
